import { render, staticRenderFns } from "./AttributesUpdater.vue?vue&type=template&id=0fb55e1c&scoped=true&"
import script from "./AttributesUpdater.vue?vue&type=script&lang=js&"
export * from "./AttributesUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb55e1c",
  null
  
)

export default component.exports